import { useEffect, useRef } from "react";
import ReactECharts from "echarts-for-react";
import { Flex } from "antd";
import "./ActionCodes.scss";

const DualBarChartECharts = ({
  negativeData = [],
  positiveData = [],
  yLabel = "No. of Cases ↓",
  leftLabel = "Positive",
  rightLabel = "Negative",
  xAxisLabel = "Action codes →",
  colors = ["#F5B041", "#58D68D"], // Optional: add two colors
  leftGrid = {
    left: "5%",
    right: "55%",
    bottom: 80,
    containLabel: true,
  },
  rightGrid = {
    left: "55%",
    right: "5%",
    bottom: 80,
    containLabel: true,
  },
}) => {
  const chartRef = useRef(null);

  const actionCodes = Array.from(
  new Set([
    ...positiveData.map((d) => d.action_code),
    ...negativeData.map((d) => d.action_code),
  ])
);


 const option = {
  title: { text: "Call Status by Action Codes" },
  tooltip: { trigger: "axis", axisPointer: { type: "shadow" } },
  xAxis: {
    type: "value",
    axisLabel: { formatter: (v) => Math.abs(v) }, // Show counts as positive numbers
  },
  yAxis: {
    type: "category",
    data: actionCodes, // shared list of codes
  },
  series: [
    {
      name: "Positive",
      type: "bar",
      stack: "total",
      label: { show: true },
      data: positiveData.map((d) => d.count), // positive values
      itemStyle: { color: "rgb(0, 178, 71)" },
    },
    {
      name: "Negative",
      type: "bar",
      stack: "total",
      label: { show: true },
      data: negativeData.map((d) => -d.count), // NEGATIVE values
      itemStyle: { color: "#ff6843" },
    },
  ],
};


  useEffect(() => {
    const instance = chartRef.current?.getEchartsInstance();
    if (!instance) return;

    const obs = new ResizeObserver(() => instance.resize());
    const dom = instance.getDom();
    obs.observe(dom);

    const handleWindowResize = () => instance.resize();
    window.addEventListener("resize", handleWindowResize);

    return () => {
      obs.disconnect();
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  return (
    <div
      className="chart-wrapper"
      style={{ position: "relative", width: "100%" }}
    >
      <Flex className="chart_container">
        <ReactECharts
          ref={chartRef}
          option={option}
          style={{ width: "100%", height: "420px" }}
          className="chart"
        />
      </Flex>
      {/* Label overlays below chart */}
      {/* <div className="chart-labels-overlay">
        <div className="label-block left">
          <div className="sideLineGreen"></div>
          <div className="line green-line" />
          <div className="label-text green">{leftLabel}</div>
          <div className="line green-line" />
          <div className="sideLineGreen"></div>
        </div>
        <div className="label-block right">
          <div className="sideLine"></div>
          <div className="line red-line" />
          <div className="label-text red">{rightLabel}</div>
          <div className="line red-line" />
          <div className="sideLine"></div>
        </div>
      </div> */}
    </div>
  );
};

export default DualBarChartECharts;
